'use strict';

function mapQuerySeparatorToKeys(key, separator) {
  var split = key.split(separator), result = split[0];
  for (var i = 1, len = split.length; i < len; i++) {
    result += '[' + split[i] + ']';
  }
  return result;
}

module.exports = mapQuerySeparatorToKeys;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/internal/mapQuerySeparatorToKeys.js
// module id = 791
// module chunks = 0